import 'vue2-leaflet';
import BLUE_MARKER_ICON from '@/assets/marker-icon-blue.png';
import RED_MARKER_ICON from '@/assets/marker-icon-red.png';
import MARKER_ICON_SHADOW from '@/assets/marker-shadow.png';
import 'leaflet-control-geocoder';
import * as L from 'leaflet';
import { latLng } from 'leaflet';

export const MAP_BASIC_CONFIGURATION = {
  zoom: 6,
  center: latLng(51.1955412, 9.8393819),
  baseUrl: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
  attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
};

export const MARKER_STYLES = {
  BLUE_MARKER: L.icon({
    iconUrl: BLUE_MARKER_ICON,
    shadowUrl: MARKER_ICON_SHADOW,
    iconAnchor: new L.Point(12, 41),
  }),
  RED_MARKER: L.icon({
    iconUrl: RED_MARKER_ICON,
    shadowUrl: MARKER_ICON_SHADOW,
    iconAnchor: new L.Point(12, 41),
  }),
};

export function addControlElements(map) {
  // Zeichnen auf der Karte
  if (map.pm) {
    map.pm.setGlobalOptions({
      markerStyle: { icon: MARKER_STYLES.BLUE_MARKER },
      templineStyle: { color: 'red' },
      hintlineStyle: { color: 'red' },
    });
    map.pm.setLang('de');
  }

  // Massstabsanzeige
  L.control
    .scale({
      position: 'bottomright',
      imperial: false,
    })
    .addTo(map);
}
